import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as nls from '../../../nls.js';
import * as arrays from '../../../base/common/arrays.js';
import { IntervalTimer } from '../../../base/common/async.js';
import { Emitter, Event } from '../../../base/common/event.js';
import { Disposable } from '../../../base/common/lifecycle.js';
export var AbstractKeybindingService = /*#__PURE__*/function (_Disposable) {
  _inherits(AbstractKeybindingService, _Disposable);

  var _super = _createSuper(AbstractKeybindingService);

  function AbstractKeybindingService(_contextKeyService, _commandService, _telemetryService, _notificationService, _logService) {
    var _this;

    _classCallCheck(this, AbstractKeybindingService);

    _this = _super.call(this);
    _this._contextKeyService = _contextKeyService;
    _this._commandService = _commandService;
    _this._telemetryService = _telemetryService;
    _this._notificationService = _notificationService;
    _this._logService = _logService;
    _this._onDidUpdateKeybindings = _this._register(new Emitter());
    _this._currentChord = null;
    _this._currentChordChecker = new IntervalTimer();
    _this._currentChordStatusMessage = null;
    _this._logging = false;
    return _this;
  }

  _createClass(AbstractKeybindingService, [{
    key: "onDidUpdateKeybindings",
    get: function get() {
      return this._onDidUpdateKeybindings ? this._onDidUpdateKeybindings.event : Event.None; // Sinon stubbing walks properties on prototype
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(AbstractKeybindingService.prototype), "dispose", this).call(this);
    }
  }, {
    key: "_log",
    value: function _log(str) {
      if (this._logging) {
        this._logService.info("[KeybindingService]: ".concat(str));
      }
    }
  }, {
    key: "getKeybindings",
    value: function getKeybindings() {
      return this._getResolver().getKeybindings();
    }
  }, {
    key: "lookupKeybindings",
    value: function lookupKeybindings(commandId) {
      return arrays.coalesce(this._getResolver().lookupKeybindings(commandId).map(function (item) {
        return item.resolvedKeybinding;
      }));
    }
  }, {
    key: "lookupKeybinding",
    value: function lookupKeybinding(commandId) {
      var result = this._getResolver().lookupPrimaryKeybinding(commandId);

      if (!result) {
        return undefined;
      }

      return result.resolvedKeybinding;
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(e, target) {
      return this._dispatch(e, target);
    }
  }, {
    key: "softDispatch",
    value: function softDispatch(e, target) {
      var keybinding = this.resolveKeyboardEvent(e);

      if (keybinding.isChord()) {
        console.warn('Unexpected keyboard event mapped to a chord');
        return null;
      }

      var _keybinding$getDispat = keybinding.getDispatchParts(),
          _keybinding$getDispat2 = _slicedToArray(_keybinding$getDispat, 1),
          firstPart = _keybinding$getDispat2[0];

      if (firstPart === null) {
        // cannot be dispatched, probably only modifier keys
        return null;
      }

      var contextValue = this._contextKeyService.getContext(target);

      var currentChord = this._currentChord ? this._currentChord.keypress : null;
      return this._getResolver().resolve(contextValue, currentChord, firstPart);
    }
  }, {
    key: "_enterChordMode",
    value: function _enterChordMode(firstPart, keypressLabel) {
      var _this2 = this;

      this._currentChord = {
        keypress: firstPart,
        label: keypressLabel
      };
      this._currentChordStatusMessage = this._notificationService.status(nls.localize('first.chord', "({0}) was pressed. Waiting for second key of chord...", keypressLabel));
      var chordEnterTime = Date.now();

      this._currentChordChecker.cancelAndSet(function () {
        if (!_this2._documentHasFocus()) {
          // Focus has been lost => leave chord mode
          _this2._leaveChordMode();

          return;
        }

        if (Date.now() - chordEnterTime > 5000) {
          // 5 seconds elapsed => leave chord mode
          _this2._leaveChordMode();
        }
      }, 500);
    }
  }, {
    key: "_leaveChordMode",
    value: function _leaveChordMode() {
      if (this._currentChordStatusMessage) {
        this._currentChordStatusMessage.dispose();

        this._currentChordStatusMessage = null;
      }

      this._currentChordChecker.cancel();

      this._currentChord = null;
    }
  }, {
    key: "_dispatch",
    value: function _dispatch(e, target) {
      return this._doDispatch(this.resolveKeyboardEvent(e), target);
    }
  }, {
    key: "_doDispatch",
    value: function _doDispatch(keybinding, target) {
      var _this3 = this;

      var shouldPreventDefault = false;

      if (keybinding.isChord()) {
        console.warn('Unexpected keyboard event mapped to a chord');
        return false;
      }

      var _keybinding$getDispat3 = keybinding.getDispatchParts(),
          _keybinding$getDispat4 = _slicedToArray(_keybinding$getDispat3, 1),
          firstPart = _keybinding$getDispat4[0];

      if (firstPart === null) {
        this._log("\\ Keyboard event cannot be dispatched."); // cannot be dispatched, probably only modifier keys


        return shouldPreventDefault;
      }

      var contextValue = this._contextKeyService.getContext(target);

      var currentChord = this._currentChord ? this._currentChord.keypress : null;
      var keypressLabel = keybinding.getLabel();

      var resolveResult = this._getResolver().resolve(contextValue, currentChord, firstPart);

      this._logService.trace('KeybindingService#dispatch', keypressLabel, resolveResult === null || resolveResult === void 0 ? void 0 : resolveResult.commandId);

      if (resolveResult && resolveResult.enterChord) {
        shouldPreventDefault = true;

        this._enterChordMode(firstPart, keypressLabel);

        return shouldPreventDefault;
      }

      if (this._currentChord) {
        if (!resolveResult || !resolveResult.commandId) {
          this._notificationService.status(nls.localize('missing.chord', "The key combination ({0}, {1}) is not a command.", this._currentChord.label, keypressLabel), {
            hideAfter: 10 * 1000
            /* 10s */

          });

          shouldPreventDefault = true;
        }
      }

      this._leaveChordMode();

      if (resolveResult && resolveResult.commandId) {
        if (!resolveResult.bubble) {
          shouldPreventDefault = true;
        }

        if (typeof resolveResult.commandArgs === 'undefined') {
          this._commandService.executeCommand(resolveResult.commandId).then(undefined, function (err) {
            return _this3._notificationService.warn(err);
          });
        } else {
          this._commandService.executeCommand(resolveResult.commandId, resolveResult.commandArgs).then(undefined, function (err) {
            return _this3._notificationService.warn(err);
          });
        }

        this._telemetryService.publicLog2('workbenchActionExecuted', {
          id: resolveResult.commandId,
          from: 'keybinding'
        });
      }

      return shouldPreventDefault;
    }
  }, {
    key: "mightProducePrintableCharacter",
    value: function mightProducePrintableCharacter(event) {
      if (event.ctrlKey || event.metaKey) {
        // ignore ctrl/cmd-combination but not shift/alt-combinatios
        return false;
      } // weak check for certain ranges. this is properly implemented in a subclass
      // with access to the KeyboardMapperFactory.


      if (event.keyCode >= 31
      /* KEY_A */
      && event.keyCode <= 56
      /* KEY_Z */
      || event.keyCode >= 21
      /* KEY_0 */
      && event.keyCode <= 30
      /* KEY_9 */
      ) {
        return true;
      }

      return false;
    }
  }]);

  return AbstractKeybindingService;
}(Disposable);